// Añade variante de bolsa al carro --------------------------------------------------------------------------------
function addToCartRecommended(button) {
  const span = button.querySelector(".cart-recommendations-text-button");
  if (span) {
    span.textContent = "Añadiendo...";
  }
  const cartItem = button.closest(".cart-recommendations-cart-item ");

  const variantInput = cartItem.getElementsByClassName(
    "cart-recommendations-form-hidden"
  );
  const variantId = variantInput ? variantInput[0].value : null;

  if (variantId) {
    axios
      .post("/cart/add.js", {
        id: variantId,
        quantity: 1,
      })
      .then((response) => {
        span.textContent = "AÑADIR AL CARRO";
        setTimeout(() => refreshCartDrawer(), 1000);
      })
      .catch((error) => {
        console.error("Error al agregar el producto al carrito:", error);
      });
  } else {
    console.error("No se encontró el variant ID.");
  }
}

//Actualiza visualmente el carro-----------------------------------------------------------------------------------
function refreshCartDrawer() {
  return fetch("/cart")
    .then((response) => response.text())
    .then((cart) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(cart, "text/html");

      const cartItems = doc.querySelector("#cart-items-list");

      if (cartItems) {
        const cartItemList = document.querySelector("#cart-items-list");
        cartItemList.innerHTML = cartItems ? cartItems.innerHTML : "";

        const drawerFooter = doc.querySelector(".drawer__footer");
        const drawerFooterOld = document.querySelector(".drawer__footer");
        drawerFooterOld.innerHTML = drawerFooter ? drawerFooter.innerHTML : "";

        const cartCountBubble = doc.querySelector(".cart-count-bubble");
        const cartCountBubbleOld = document.querySelector(".cart-count-bubble");
        cartCountBubbleOld.innerHTML = cartCountBubble
          ? cartCountBubble.innerHTML
          : "";
      } else {
        const cartEmpty = doc.querySelector("cart-drawer");
        const cartEmptyOld = document.querySelector("cart-drawer");
        cartEmptyOld.innerHTML = cartEmpty ? cartEmpty.innerHTML : "";

        const cartCountBubble = doc.querySelector(".cart-count-bubble");
        const cartCountBubbleOld = document.querySelector(".cart-count-bubble");
        cartCountBubbleOld.innerHTML = cartCountBubble
          ? cartCountBubble.innerHTML
          : "";
      }
    })
    .catch((error) => console.error("Error updating cart drawer:", error));
}

document.addEventListener("DOMContentLoaded", () => {
  // Crea un observer para detectar cambios en el DOM
  const observer = new MutationObserver(() => {
    // Verifica si el elemento '.cart-recommendations-cart-item' ha aparecido
    const items = document.querySelectorAll(".cart-recommendations-cart-item");

    if (items.length > 0) {
      items.forEach((item) => {
        // Aquí puedes ejecutar la lógica para trabajar con el nuevo item
        const selectSizeButton = item.querySelector(".select-size-button");
        const addToCartButton = item.querySelector(
          ".cart-recommendations-button-add"
        );
        const closeButton = item.querySelector(
          ".close-variants-buttons-recommended"
        );
        const variantButtons = item.querySelector(
          ".cart-recommendations-bag-message"
        );

        if (
          selectSizeButton &&
          addToCartButton &&
          closeButton &&
          variantButtons
        ) {
          selectSizeButton.addEventListener("click", () => {
            if (addToCartButton) {
              addToCartButton.setAttribute(
                "style",
                "display: block !important;"
              );
              selectSizeButton.setAttribute(
                "style",
                "display: none !important;"
              );
              variantButtons.setAttribute(
                "style",
                "display: block !important;"
              );
            }
          });

          closeButton.addEventListener("click", () => {
            if (variantButtons) {
              addToCartButton.setAttribute(
                "style",
                "display: none !important;"
              );
              selectSizeButton.setAttribute(
                "style",
                "display: block !important;"
              );
              variantButtons.setAttribute("style", "display: none !important;");
            }
          });
        }
      });
    }
  });

  // Configura el observer para observar el cuerpo del documento por cambios
  const config = { childList: true, subtree: true };
  observer.observe(document.body, config);
});

// Permite estar observando si es necesario extender o no el width del carro -----------------------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  const cartDrawer = document.querySelector("cart-drawer.drawer");
  const cartRecommendations = document.querySelector("cart-recommendations");

  if (!cartDrawer) {
    console.error("El elemento cartDrawer no se encontró en el DOM");
    return;
  }

  if (!cartRecommendations) {
    return;
  }

  function updateCart() {
    const drawerInner = document.querySelector(".drawer__inner");

    if (!drawerInner) {
      console.warn("El elemento drawerInner no se encontró en el DOM");
      return;
    }

    if (cartDrawer.classList.contains("is-empty")) {
      drawerInner.style.cssText += "width: 40rem !important;";
    } else {
      drawerInner.style.cssText += "width: 72rem !important;";
    }
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        updateCart();
      }
    });
  });

  observer.observe(cartDrawer, { attributes: true });

  updateCart();
});

document.querySelectorAll(".cart-recommendations-cart-item").forEach((card) => {
  const selectSizeButton = card.querySelector(".select-size-button");
  const addToCartButton = card.querySelector(
    ".cart-recommendations-button-add"
  );

  const closeButton = card.querySelector(".close-variants-buttons-recommended");
  const variantButtons = card.querySelector(
    ".cart-recommendations-bag-message"
  );

  if (selectSizeButton) {
    selectSizeButton.addEventListener("click", () => {
      if (addToCartButton) {
        addToCartButton.setAttribute("style", "display: block !important;");
        selectSizeButton.setAttribute("style", "display: none !important;");
        variantButtons.setAttribute("style", "display: block !important;");
      }
    });
  }

  closeButton.addEventListener("click", () => {
    if (variantButtons) {
      addToCartButton.setAttribute("style", "display: none !important;");
      selectSizeButton.setAttribute("style", "display: block !important;");
      variantButtons.setAttribute("style", "display: none !important;");
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(
    ".card-wrapper .product-form__submit"
  );

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const drawerInner = document.querySelector(".drawer__inner");

      if (drawerInner) {
        const hasClasses =
          drawerInner.classList.contains("cart-drawer-pinflag-flex-column") &&
          drawerInner.classList.contains("cart-drawer-pinflag-width");

        if (!hasClasses) {
          drawerInner.classList.add(
            "cart-drawer-pinflag-flex-column",
            "cart-drawer-pinflag-width"
          );
        }
      }
    });
  });
});

function handleAddToCart(event, button) {
  event.preventDefault();

  const productCard = button.closest(".product-card-wrapper");

  const selectedVariantId = productCard.querySelector(
    ".selected-variant-id"
  ).value;

  button.setAttribute("disabled", true);
  button.innerHTML = "<span>Añadiendo...</span>";

  const formData = {
    id: selectedVariantId,
    quantity: 1,
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((item) => {
      updateCartDrawer(true);
    })
    .catch((error) => {
      console.error("Error al añadir al carrito:", error);
    })
    .finally(() => {
      button.removeAttribute("disabled");
      button.innerHTML = "<span>AÑADIR AL CARRITO</span>";
    });
}

function changeImageFromVariant(button) {
  const productCard = button.closest(".product-card-wrapper");
  if (!productCard) {
    return;
  }

  const featureImageUrl = button.dataset.featureImage;
  if (!featureImageUrl || featureImageUrl.includes("Liquid error")) {
    return;
  }

  const productImage1 = productCard.querySelector(
    ".card__media .product_image_1"
  );
  if (productImage1) {
    productImage1.src = featureImageUrl;
    productImage1.srcset = featureImageUrl;
  }
  const productImage2 = productCard.querySelector(
    ".card__media .product_image_2"
  );
  if (productImage2) {
    productImage2.src = featureImageUrl;
    productImage2.srcset = featureImageUrl;
  }
}

function initializeProductCards() {
  const productCards = document.querySelectorAll(".product-card-wrapper");
  productCards.forEach(initializeProductCard);

  // Comprobación específica para la página de resultados de búsqueda
  if (window.location.pathname.includes("/search")) {
    productCards.forEach((card) => {
      const defaultProductUrl = card.querySelector(".card__heading a").href;
      updateVariantSelector(card, defaultProductUrl, true);
    });
  }
}

function initializeProductCard(productCard) {
  const defaultProductUrl = productCard.querySelector(".card__heading a").href;
  updateVariantSelector(productCard, defaultProductUrl);

  const defaultColorSwatch = productCard.querySelector(
    ".variant_color_swatches.select_variant"
  );
  if (defaultColorSwatch) {
    defaultColorSwatch.classList.add("selected");
  }

  const addToCartForm = productCard.querySelector(".product-form");
  if (addToCartForm) {
    addToCartForm.addEventListener("submit", handleAddToCart);
  }
}

function initializeInfiniteScroll() {
  const infiniteScrollElement = document.querySelector("infinite-scroll");
  if (infiniteScrollElement) {
    infiniteScrollElement.addEventListener("productsLoaded", function (event) {
      const newProducts = event.detail.newProducts;
      newProducts.forEach(initializeProductCard);
    });
  }
}

function initializeCartDrawer() {
  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    if (!cartDrawer.open) {
      cartDrawer.open = function () {
        this.classList.add("animate", "active");
        document.body.classList.add("overflow-hidden");
      };
    }

    if (!cartDrawer.close) {
      cartDrawer.close = function () {
        this.classList.remove("active");
        document.body.classList.remove("overflow-hidden");
      };
    }

    const overlay = cartDrawer.querySelector("#CartDrawer-Overlay");
    if (overlay) {
      overlay.addEventListener("click", () => cartDrawer.close());
    }
  }
}

function changeProductPLP(element) {
  const parent = element.closest(".product-card-wrapper");

  if (!parent) {
    console.error("No se encontró el contenedor del producto.");
    return;
  }

  const featureImageUrl1 = element.dataset.featureImage;
  const featureImageUrl2 = element.dataset.featureImage2;
  const productUrl = element.dataset.productUrl;
  const productName = element.dataset.productName;

  const productImage1 = parent.querySelector(".card__media .product_image_1");
  const productImage2 = parent.querySelector(".card__media .product_image_2");
  const currentInformation = parent.querySelectorAll(".card__heading a");

  if (!productImage1 || !productImage2 || !currentInformation.length) {
    console.error("Elementos necesarios no encontrados.");
    return;
  }

  updateProductImages(
    productImage1,
    productImage2,
    featureImageUrl1,
    featureImageUrl2
  );
  updateProductInformation(currentInformation, productName, productUrl);
  updateSelectedSwatch(parent, element);
  updateVariantSelector(parent, productUrl, true); // Forzar actualización de variantes
}

function updateProductImages(image1, image2, url1, url2) {
  [image1, image2].forEach((img, index) => {
    img.src = index === 0 ? url1 : url2;
    img.srcset = index === 0 ? url1 : url2;
  });
}

function updateProductInformation(infoElements, name, url) {
  infoElements.forEach((element) => {
    element.textContent = name;
    element.href = url;
  });
}

function updateSelectedSwatch(parent, selectedElement) {
  parent.querySelectorAll(".variant_color_swatches").forEach((swatch) => {
    swatch.classList.remove("selected");
  });
  selectedElement.classList.add("selected");
}

function updateVariantSelector(parent, productUrl, forceUpdate = false) {
  const variantSelector = parent.querySelector(".product-variant-selector");

  const variantButtons = parent.querySelector(".variant-buttons");

  const productForm = parent.querySelector(".product-form");

  const selectedVariantInput = parent.querySelector(".selected-variant-id");

  const submitButton = parent.querySelector(".product-variant-submit-button");

  const soldOutMessage = parent.querySelector(".sold-out-message");

  if (
    !variantSelector ||
    !variantButtons ||
    !productForm ||
    !selectedVariantInput
  ) {
    console.error(
      "Elementos necesarios no encontrados para el selector de variantes."
    );
    return;
  }

  // Si los botones de variantes ya existen y no se fuerza la actualización, salimos de la función
  if (variantButtons.children.length > 0 && !forceUpdate) {
    return;
  }

  fetch(productUrl + ".js")
    .then((response) => response.json())
    .then((product) => {
      const availableVariants = product.variants.filter((v) => v.available);

      if (availableVariants.length === 0) {
        variantSelector.style.display = "none";
        soldOutMessage.style.display = "flex";
      } else {
        variantSelector.style.display = "block";
        soldOutMessage.style.display = "none";

        renderVariantButtons(variantButtons, product.variants);

        if (availableVariants.length > 0) {
          selectVariant(parent, availableVariants[0].id);
        }
      }
    })
    .catch((error) => console.error("Error al cargar las variantes:", error));
}

function renderVariantButtons(container, variants) {
  container.innerHTML = "";
  variants.forEach((variant) => {
    const button = createVariantButton(variant);
    container.appendChild(button);
  });
}

function createVariantButton(variant) {
  const button = document.createElement("button");
  button.type = "button";
  button.classList.add("variant-button");
  if (!variant.available) {
    button.classList.add("unavailable");
  }
  button.textContent = variant.title.split("/")[0].trim();
  button.dataset.variantId = variant.id;

  button.addEventListener("click", function (e) {
    e.preventDefault();
    if (variant.available) {
      selectVariant(this.closest(".product-card-wrapper"), variant.id);
    }
  });

  return button;
}

function selectVariant(parent, variantId) {
  const variantButtons = parent.querySelectorAll(".variant-button");
  const selectedVariantInput = parent.querySelector(".selected-variant-id");
  const submitButton = parent.querySelector(".product-variant-submit-button");

  variantButtons.forEach((button) => {
    button.classList.toggle(
      "selected",
      button.dataset.variantId === variantId.toString()
    );
  });

  selectedVariantInput.value = variantId;
  submitButton.disabled = false;
}

function handleAddToCart(event) {
  event.preventDefault();
  const form = event.target.closest('form');

  const submitButton = form.querySelector('[type="submit"]');
  const originalButtonText = submitButton.innerHTML;

  submitButton.setAttribute("disabled", true);
  submitButton.innerHTML = "<span>Añadiendo...</span>";

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(Object.fromEntries(new FormData(form))),
  })
    .then((response) => response.json())
    .then((item) => {
      updateCartDrawer(true);
      updateCartIconBubble(); // Actualizar el icono del carrito inmediatamente
    })
    .catch((error) => {
      console.error("Error al añadir al carrito:", error);
    })
    .finally(() => {
      submitButton.removeAttribute("disabled");
      submitButton.innerHTML = originalButtonText;
    });
}

function updateCartDrawer(openDrawer = false) {
  fetch("/?section_id=cart-drawer")
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(html, "text/html");
      const newDrawerContent = newDocument.querySelector(".drawer__inner");
      const cartDrawer = document.querySelector("cart-drawer");

      if (newDrawerContent && cartDrawer) {
        const currentDrawerContent = cartDrawer.querySelector(".drawer__inner");
        currentDrawerContent.innerHTML = newDrawerContent.innerHTML;
        currentDrawerContent.style.width = '80rem';
        currentDrawerContent.style.flexDirection = 'row';

        const newCartDrawerElement = newDocument.querySelector("cart-drawer");
        const isEmpty = newCartDrawerElement ? newCartDrawerElement.classList.contains("is-empty") : false;

        cartDrawer.classList.toggle("is-empty", isEmpty);

        if (openDrawer) {
          cartDrawer.open();
        }
      }

      updateCartIconBubble();
    })
    .catch((error) => {
      console.error("Error al actualizar el carrito:", error);
    });
}

function updateCartIconBubble() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const cartIconBubble = document.querySelector("#cart-icon-bubble");
      if (cartIconBubble) {
        const itemCount = cart.item_count;
        const counterElement = cartIconBubble.querySelector(
          ".cart-count-bubble span"
        );

        if (counterElement) {
          counterElement.textContent = itemCount;
          counterElement
            .closest(".cart-count-bubble")
            .classList.toggle("hide", itemCount === 0);
        } else {
          const newCounterElement = document.createElement("div");
          newCounterElement.className = "cart-count-bubble";
          newCounterElement.innerHTML = `<span aria-hidden="true">${itemCount}</span><span class="visually-hidden">${itemCount} artículo(s)</span>`;
          cartIconBubble.appendChild(newCounterElement);
        }
      }
    })
    .catch((error) => {
      console.error("Error al actualizar el icono del carrito:", error);
    });
}
